// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoLayout_container__ITcdC"};